<ng-template #template>
    <ng-container *ngIf="model.isVisible">
        <sv-ng-list [model]="model.list"></sv-ng-list>
    </ng-container>
</ng-template>